<script>
	export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	@import "@/uni_modules/uview-ui/index.scss";
	/*每个页面公共css */
	body{
		background: #f5f7fa;
	}
	
	.myRadio{
		  ::v-deep .picked{
		    border: 1.5px solid #2979ff !important;;
			
		    ::v-deep .u-radio__icon-wrap,.u-checkbox__icon-wrap{
		      border-color: #fff !important;
		      text{
		        color: #fff !important;
		      }
		    }
		    text{
		      color: #2979ff !important;
		    }
		  }
		  ::v-deep .wronged{
		    border: 1.5px solid #ed6464 !important;;
		
		    ::v-deep.u-radio__icon-wrap,.u-checkbox__icon-wrap{
		      border-color: #fff !important;
		      text{
		        color: #fff !important;
		      }
		    }
		    text{
		      color: #ed6464 !important;
		    }
		  }
		}
</style>
